import info from '~/package.json'
import capacitor from './capacitor'

function getUserAgent (agent) {
  return Array.from((agent || navigator.userAgent).matchAll(/(?:^| )([^/]+)\/([^ ]+)(?: \(([^)]+)\))?/g)).map(r => ({
    name: r[1],
    version: r[2],
    details: r[3] ? String(r[3]).split(';').map(s => s.trim()) : []
  }))
}

const isIos = navigator.userAgent.indexOf('iPhone') >= 0 || navigator.userAgent.indexOf('iPad') >= 0
const isAndroid = navigator.userAgent.indexOf('Android') >= 0
const isCap = capacitor.check()

export default {
  appName: info.name,
  appVersion: info.version.substr(0, info.version.indexOf('+')),
  appFullVersion: info.version,
  isWeb: true,
  isCap,
  isIos,
  isAndroid,
  isNative: false,
  isSmallScreen: () => document.body.offsetWidth < 800,
  isBigScreen: () => document.body.offsetWidth >= 800,
  platform: isCap ? (isAndroid ? 'android' : (isIos ? 'ios' : 'unknown')) : 'web',
  mode: process.env.NODE_ENV,
  system: {
    appCodeName: navigator.appCodeName,
    appName: navigator.appName,
    appVersion: navigator.appVersion,
    cookieEnabled: navigator.cookieEnabled,
    language: navigator.language,
    onLine: navigator.onLine,
    platform: navigator.platform,
    userAgent: navigator.userAgent
  },
  locale: navigator.language,
  width: window.innerWidth,
  height: window.innerHeight,
  scale: 1,
  offsetTop: 0,
  offsetBottom: 0,
  basePathCss: '',
  setStatusBarColor () {
  },
  getUserAgent
}